import React from 'react';

const nodeTypes = [
  { label: 'Firewall',       color: '#38bdf8', shape: '🛡' },
  { label: 'Router',         color: '#38bdf8', shape: '⬡' },
  { label: 'Switch',         color: '#38bdf8', shape: '◈' },
  { label: 'Server',         color: '#a78bfa', shape: '▣' },
  { label: 'Access Point',   color: '#34d399', shape: '◎' },
  { label: 'Postazione',     color: '#94a3b8', shape: '◻' },
];

const edgeTypes = [
  { label: 'Fibra',     color: '#38bdf8', dash: false },
  { label: 'Rame',      color: '#94a3b8', dash: false },
  { label: 'Wireless',  color: '#34d399', dash: true },
  { label: 'VPN',       color: '#a78bfa', dash: true },
];

const statusTypes = [
  { label: 'Online',        color: '#22c55e' },
  { label: 'Degradato',     color: '#f59e0b' },
  { label: 'Offline',       color: '#ef4444' },
  { label: 'Manutenzione',  color: '#3b82f6' },
];

export default function TopologyLegend() {
  return (
    <div className="bg-surface/90 border border-border rounded-xl p-3 backdrop-blur-sm shadow-xl text-sm max-w-[240px]">
      <p className="text-xs font-bold text-muted-color uppercase tracking-widest mb-2">Legenda</p>
      <div className="grid grid-cols-2 gap-x-4 gap-y-1.5 mb-3">
        {nodeTypes?.map((t) => (
          <span key={`leg-node-${t?.label}`} className="flex items-center gap-1.5 text-secondary-color">
            <span style={{ color: t?.color }} className="text-base leading-none">{t?.shape}</span>
            <span className="text-xs font-semibold">{t?.label}</span>
          </span>
        ))}
      </div>
      <div className="border-t border-border pt-2 mb-2 space-y-1.5">
        {edgeTypes?.map((e) => (
          <span key={`leg-edge-${e?.label}`} className="flex items-center gap-2 text-secondary-color">
            <svg width="20" height="8">
              <line
                x1="0" y1="4" x2="20" y2="4"
                stroke={e?.color}
                strokeWidth="1.5"
                strokeDasharray={e?.dash ? '4 3' : 'none'}
              />
            </svg>
            <span className="text-xs font-semibold">{e?.label}</span>
          </span>
        ))}
      </div>
      <div className="border-t border-border pt-2 flex flex-wrap gap-x-3 gap-y-1.5">
        {statusTypes?.map((s) => (
          <span key={`leg-status-${s?.label}`} className="flex items-center gap-1.5 text-secondary-color">
            <span className="w-2.5 h-2.5 rounded-full flex-shrink-0" style={{ backgroundColor: s?.color }} />
            <span className="text-xs font-semibold">{s?.label}</span>
          </span>
        ))}
      </div>
    </div>
  );
}